import { Helmet } from "react-helmet-async"
import React, { useLayoutEffect, useContext } from "react"
import AuthContext from "../../context/auth/authContext"
import { useNavigate } from "react-router-dom"
import { Container } from "reactstrap"
import OnboardingSurvey from "components/Typeform/OnboardingSurvey"
import ilustracion from "assets/customIcons/ilustracion.svg"
import logoLarge from "assets/customIcons/logos/planhopper_logo_large.svg"

const SurveyTypeForm = props => {
  const { getUser } = useContext(AuthContext)
  const navigate = useNavigate()

  useLayoutEffect(() => {
    let userAuth = JSON.parse(localStorage.getItem("userAuth"))
    if (userAuth) {
      userAuth["custom:onboarding"] === "true" ? navigate("/dashboard") : null
    } else {
      getUser()
    }
  }, [])
  return (
    <React.Fragment>
      <div
        className="LayoutHubspot"
        style={{
          zIndex: "999",
          width: "100%",
          backgroundColor: "#E5E5E5",
          marginLeft: "-16px",
          height: "100%",
          marginTop: "-40px",
          paddingTop: "120px",
          position: "absolute",
          overflow: "hidden",
        }}
      >
        <Helmet>
          <title>Planhopper | Bienvenida</title>
        </Helmet>
        <div className="inline">
          <a
            href="https://www.planhopper.com"
            target="_blank"
            rel="noreferrer"
            style={{ zIndex: "99" }}
          >
            <img
              className="logoPositioning"
              style={{ top: "8%" }}
              src={logoLarge}
              width="147px"
              height="45px"
            />
          </a>
        </div>
        <Container fluid>
          <OnboardingSurvey />
          <img
            className="AnimationHubspot"
            src={ilustracion}
            style={{
              width: "100%",
              maxWidth: "100%",
              height: "360px",
              marginLeft: "-17px",
              bottom: "-12px",
              position: "absolute",
              zIndex: "-1",
            }}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default SurveyTypeForm
